import { Language } from '../../types/language'

export type WelcomeCopy = {
  heading: string
  paragraphs: string[]
  quote: string
  imageAlt: string
}

export const welcomeCopy: Record<Language, WelcomeCopy> = {
  nl: {
    heading: 'Hier begint jouw volgende avontuur',
    paragraphs: [
      'Ik begeleid mensen die zich overweldigd voelen, vastlopen of op een kruispunt staan.',
      'Het moderne leven trekt onze aandacht constant naar buiten: verwachtingen, druk, eindeloze keuzes, social media en FOMO. Er blijft weinig ruimte over om stil te staan bij wat voor jou echt belangrijk is.',
      'Als coach werk ik naast je, niet boven je. Samen vertragen we, zoeken we helderheid en maak je opnieuw verbinding met de richting die voor jou goed voelt.',
      'Mijn traject in vier stappen combineert reflectie, toekomstbeeld en praktische actie, zodat je met vertrouwen keuzes maakt en een leven opbouwt dat echt van jou is.',
    ],
    quote:
      'Want echte transformatie gaat niet over veranderen wie je bent. Het gaat over je herinneren wie je altijd al was.',
    imageAlt: 'Mark loopt weg van de camera over het pad',
  },
  en: {
    heading: 'This is where your next adventure begins',
    paragraphs: [
      'I support people who feel overwhelmed, stuck, or at a crossroads.',
      'Modern life constantly pulls our attention outward: expectations, pressure, endless choices, social media, and FOMO. Little space is left to reflect on what truly matters to you.',
      'As a coach I work alongside you, not above you. Together we slow down, find clarity, and reconnect you with the direction that feels right for you.',
      'My four-step journey combines reflection, future focus, and practical action, so you make confident choices and build a life that is truly yours.',
    ],
    quote:
      "Because true transformation is not about changing who you are. It's about remembering who you've always been.",
    imageAlt: 'Mark walking away from the camera along the path',
  },
}
